<template>
  <div class="m-search-dialog">
    <div class="search-dialog" v-if="searchVisible">
      <div class="title">
        <span>{{ quickType.label }}</span>
        <i class="el-icon-close" @click="visible = false"></i>
      </div>
      <div class="body">
        <!--        <van-tabs :border="false" v-model="activeName">-->
        <!--          <van-tab title="新建主题"></van-tab>-->
        <!--          <van-tab title="选择已发布的主题"></van-tab>-->
        <!--        </van-tabs>-->
        <div v-if="activeName === 1">
          <el-input placeholder="请输入查找的内容" v-model="keyword" ref="input" size="mini" @keyup.native.enter="changeHandle" class="input-with-select">
            <el-select @change="changeHandle" v-model="tags" slot="prepend">
              <el-option v-for="item in searchTypes" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <el-button @click="changeHandle" slot="append" :icon="loading ? 'el-icon-loading' : 'el-icon-search'"></el-button>
          </el-input>
          <ul class="scroll-body">
            <li v-if="totalCount === 0 && !loading">
              <el-divider>暂无更多消息</el-divider>
            </li>
            <li :class="[activeMesgId === info.msgId && 'active']" v-for="info in messageList" :key="info.msgId" @click="clickMessageHandle(info)">
              <el-checkbox :value="info.msgId === activeMesgId"></el-checkbox>
              <div class="m-message">
                <el-avatar shape="square" icon="el-icon-user" :src="info.avatar"></el-avatar>
                <div class="info">
                  <p style="font-size: 12px; color: #000;width: auto">
                    {{ info.company }}
                  </p>
                  <p style="font-size: 12px; color: #999;width: auto">
                    {{ info.name }}
                  </p>
                  <div class="pre-box">
                    <el-button v-for="item in info.ats" :key="item.at" type="text">@{{ item.atName }}</el-button>
                    <pre v-html="info.txt"></pre>
                  </div>
                  <div class="image-box" :style="{ height: '60px', overflow: 'hidden' }" v-if="info.imgs">
                    <div class="image" v-for="(item, index) in info.imgs" :key="index">
                      <div v-if="index === 3 && info.imgs.length > 4" class="more-btn">
                        <i class="el-icon-more"></i>
                        共{{ info.imgs.length }}个
                      </div>
                      <el-image :src="item">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="bottom-box">
                    <div class="left">
                      <span v-if="info.isTop">已置顶</span>
                      <span v-if="info.bcStatus === 1">已出价</span>
                      <span v-else-if="info.bcStatus === 2">正在广播</span>
                    </div>
                    <div class="right">{{ info.time }}</div>
                  </div>
                </div>
              </div>
            </li>
            <el-divider v-if="totalCount && totalCount <= this.messageList.length && !loading">暂无更多信息</el-divider>
          </ul>
        </div>
      </div>
    </div>

    <div v-else class="quick-internal-dialog dialog">
      <div class="title">
        <span>{{ quickType.label }}</span>
        <i @click="$emit('close')" class="el-icon-close"></i>
      </div>
      <div class="body dialog">
        <top-dialog
          :info="info"
          v-if="quickType.name === 'topic'"
          :switch-handle="switchHandle"
          :has-join="info.isTop"
          :visible.sync="visible"
          @success="successHandle"
        ></top-dialog>
        <broad-dialog
          v-if="quickType.name === 'broadcast'"
          :is-quick="true"
          :switch-handle="switchHandle"
          :has-join="info.bcStatus === 1"
          :visible.sync="visible"
          @success="successHandle"
          :info="info"
        ></broad-dialog>
        <red-dialog
          v-if="quickType.name === 'red'"
          :switch-handle="switchHandle"
          :is-quick="true"
          :visible.sync="visible"
          @success="successHandle"
          :info="info"
        ></red-dialog>
        <reward-dialog
          v-if="quickType.name === 'reward'"
          :switch-handle="switchHandle"
          :is-quick="true"
          :visible.sync="visible"
          @success="successHandle"
          :info="info"
        ></reward-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import Chat from "@/api/chat";
import Tags from "@/components/tags";
import TopDialog from "@/components/dialog/Topic";
import BroadDialog from "@/components/dialog/Broad";
import RedDialog from "@/components/dialog/Red";
import RewardDialog from "@/components/dialog/Reward";
export default {
  data() {
    return {
      ats: [],
      pageSize: 100,
      pageIndex: 0,
      totalCount: -1,
      loading: false,
      keyword: "",
      visibleType: "",
      searchVisible: true,
      activeMesgId: "",
      tags: "全部",
      visible: true,
      messageList: [],
      msgIdList: [],
      activeName: 1
    };
  },
  computed: {
    searchTypes() {
      const searchTypes = [
        {
          label: "全部",
          value: ""
        }
      ];
      Tags.map(item => searchTypes.push(item));
      return searchTypes;
    },
    userId() {
      return this.$store.state.userId;
    },
    info() {
      const index = this.messageList.findIndex(item => item.msgId === this.activeMesgId);
      return this.messageList[index] || {};
    }
  },
  props: {
    quickType: Object
  },
  watch: {
    visible(newValue) {
      if (newValue === false) {
        this.$emit("close");
      }
    }
  },
  components: { TopDialog, BroadDialog, RedDialog, RewardDialog },
  methods: {
    switchHandle() {
      this.searchVisible = true;
    },
    successHandle() {
      if (this.quickType.name === "top") {
        const index = this.messageList.findIndex(item => item.msgId === this.activeMesgId);
        this.$set(this.messageList[index], "isTop", true);
      }
    },
    clickMessageHandle(info) {
      this.activeMesgId = info.msgId;
      this.searchVisible = false;
    },
    changeHandle() {
      this.pageIndex = 1;
      this.messageList = [];
      this.msgIdList = [];
      this.loading = false;
      this.totalCount = -1;
      this.activeMesgId = "";
      this.getMessageList();
      this.$nextTick(() => this.$refs.input.focus());
    },
    more() {
      if (this.loading) {
        return false;
      }
      this.pageIndex += 1;
      if (this.messageList.length < this.totalCount) {
        this.getMessageList();
      }
    },
    async getMessageList() {
      this.loading = true;
      const postData = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId: this.userId,
        keyword: this.keyword,
        tags: this.tags,
        orderby: "time"
      };
      if (postData.tags === "全部") {
        postData.tags = "";
        postData.searchType = "allTopic";
      }
      let result = await Chat.myHistory(postData);
      this.loading = false;
      if (result) {
        this.totalCount = result.TotalCount;
        result.ResultList.map(item => {
          item.time = this.$timeFormat(item.t);
          if (!this.msgIdList.includes(item.msgId)) {
            this.messageList.push(item);
            this.msgIdList.push(item.msgId);
          }
        });
      }
    }
  },
  created() {
    this.getMessageList();
  }
};
</script>
<style lang="scss">
.m-search-dialog {
  z-index: 100;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .title {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    height: 40px;
    font-weight: bold;
    i {
      cursor: pointer;
    }
  }
  .el-icon-close {
    margin-top: -10px;
    font-size: 20px;
    color: #999;
  }
  .search-dialog {
    display: flex;
    flex-direction: column;
    .body {
      padding: 0 15px;
    }
    .input-with-select {
      margin-bottom: 8px;
    }
    .van-tabs__wrap {
      border-bottom: 1px solid #e6eaee;
      margin-bottom: 15px;
    }
  }
  .info-box {
    display: flex;
    font-size: 12px;
    align-items: center;
    height: 40px;
    .el-avatar {
      width: 30px;
      height: 30px;
    }
    .text {
      padding-left: 10px;
      display: inline-block;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .tag-box {
    padding: 10px;
  }
  .message-list {
    padding: 10px;
    > div {
      border-bottom: 1px solid #eee;
    }
  }
  .context {
    position: relative;
    .time {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #999;
    }
  }
  .el-select .el-input {
    width: 80px;
  }
  .van-tabs__content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .scroll-body {
    position: relative;
    width: 100%;
    height: 60vh;
    min-height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    .el-divider__text {
      color: #999;
    }
    li {
      position: relative;
      display: flex;
      width: 100%;
      margin-bottom: 8px;
      .el-checkbox {
        margin-top: 30px;
        display: inline-block;
        flex-shrink: 0;
        width: 30px;
        .el-checkbox__inner {
          border-radius: 50%;
        }
      }
    }
    .m-message {
      position: relative;
      padding: 10px;
      cursor: pointer;
      background-color: #f0f0f0;
      .bottom-box {
        display: flex;
        justify-content: space-between;
        line-height: 17px;
      }
      .right {
        color: #999;
      }
      .left {
        color: #b3c2df;
        span {
          margin-right: 5px;
        }
      }
      p {
        display: inline-block;
      }
      .info {
        padding-bottom: 0;
      }
      .pre-box {
        padding-bottom: 5px;
        pre {
          width: 100%;
        }
      }
      .image-box {
        width: auto;
        padding-bottom: 5px;
      }
      &.active {
        background-color: #e3f2fd;
      }
    }
  }
}
.quick-internal-dialog {
  position: relative;
  width: 95%;
  margin: 0 auto;
  .body {
    margin-top: -10px;
    padding: 10px;
  }
  .el-input {
    margin-bottom: 10px;
  }
  input {
    padding-right: 0;
  }
}
</style>
